import './polyfills/assign.js'; // For IE 11

import * as variables from './variables.js';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup"; 

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';

const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggerWrap: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.menu-item-has-children > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

import initInspiration from './component/Inspiration/Inspiration';
initInspiration();

import productGallery from './component/ProductGallery/ProductGallery';
productGallery();

import initAnnotations from './component/Annotations/Annotations';
initAnnotations();

import SiteAnimations from './component/SiteAnimations';
const animatedStripes = ['section > .wp-block-group', '.browseFinishes', '.contactArea', '.formStripe', '.inspiration', '.listItemGroup', '.resources', '.richContent'];

new SiteAnimations([
	{
		observedSelector: animatedStripes.join(', '),
		options: {
			rootMargin: '-50px 0px',
			threshold: 0
		}
	},
	{
		observedSelector: '.masthead, .articleMasthead, ' + animatedStripes.join(':first-child, '),
		options: {
			rootMargin: '0px 0px',
			threshold: 0
		}
	},
]);

import initBrowseFinishes from './component/BrowseFinishes/BrowseFinishes';
initBrowseFinishes();

// ----------------------------------------------------------------------------------------------
// Filter Interfaces - products
import './lib/GenericSearch';
import './lib/AjaxCart';
import './lib/QuantityHelper';

// When category link clicked update query parameters on it if current page has parameters
//  by merging links params with page's params
const $productCategoriesLinks = $('a.productCategories__category');
if ($productCategoriesLinks.length > 0) {
	$productCategoriesLinks.on('click', (e) => {
		if (e.currentTarget instanceof HTMLAnchorElement) {
			const href = new URL(e.currentTarget.href);

			const curr = new URLSearchParams(window.location.search);

			curr.forEach((value, key) => {
				href.searchParams.set(key, value);
			});


			location.href = href.toString();

			e.preventDefault();
		}
	});
}